import React from 'react';

const WebNotifPermission = (props) => {
    const isMobile = ((typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1)),
    classes = isMobile ? "b0 h428 l0 mA pF r0 t0 taC z10" : "pF h305 t4 l132 mA z10 taL",
    textWidth = (isMobile) ? "100%" : "325px";
    return(
        <React.Fragment>
            <div className="pF t0 l0 hp100 wp100" style={{"backgroundColor":"rgba(0,0,0,0.85)","zIndex":"99999"}}></div>
            <div className={classes} style={{"zIndex":"99999"}}>
                {(isMobile) ? (
                    <React.Fragment>
                        <div className="h42 pb10 wp100">
                            <img className="br4 ofC opC w310 h42" src="https://img1.junaroad.com//assets/images/mobileNotif/img-1623136615076.jpg"/>
                        </div>
                        <div className="h280">
                            <img className="opC ofC hp100 br4" src="https://img1.junaroad.com//assets/images/mobileNotif/img-1623136615031.jpg"/>
                        </div>
                    </React.Fragment>
                ) : (
                    <div className="hp100">
                        <img className="opC ofC hp100 br4" src="https://img1.junaroad.com//assets/images/mobileNotif/img-1623309382203.jpg"/>
                    </div>
                )}
                <div className="cF fs14 ls1 pt20 taC p016 bs" style={{"width":textWidth}}>
                    Allow notifications to get regular updates, click the lock icon on the address bar and select allow<br/>
                    <span className="cF fs14 lh20 ls1 pt8 dIb cuP tdU" onClick={props.togglePopup}>I will do this later</span>
                </div>
                
            </div>
        </React.Fragment>
    )
}

export default WebNotifPermission;